<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12>
          <h3 class="text-center">Professionals</h3>
        </v-flex>
        <v-flex xs12 md12 sm12>
          <v-card>
            <v-card-title class="py-1">
              <v-text-field label="Search" v-model="filterBy" prepend-icon="search" :disabled="professionals.length < 1" dense></v-text-field>
              <v-spacer></v-spacer>
              <v-select label="Profession" v-model="pro" :items="professions" item-value="name" item-text="name" clearable dense></v-select>
              <v-menu :close-delay="1000">
                <template v-slot:activator="{ attrs, on }">
                  <v-btn small text outlined :title="status ? 'View all Professionals' : 'View activated professionals'" v-bind="attrs" v-on="on" class="mx-2">
                    <v-icon left>mdi-filter-menu</v-icon>Filter
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item @click="status = 'activated'" :disabled="status == 'activated'">
                    <v-list-item-content>
                      <v-list-item-title>Activated Professionals</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="status = 'unactivated'" :disabled="status == 'unactivated'">
                    <v-list-item-content>
                      <v-list-item-title>Unactivated Professionals</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="status = null" :disabled="!status || status == 'null'">
                    <v-list-item-content>
                      <v-list-item-title>All Professionals</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-menu>
                <template v-slot:activator="{ attrs, on }">
                  <v-btn small icon fab text color="orange" v-bind="attrs" v-on="on">
                    <v-icon>{{ icons.help }}</v-icon>
                  </v-btn>
                </template>
                <v-card flat>
                  <v-card-text>
                    <h3>Activating Professionals</h3>
                    <activating-professional-help></activating-professional-help>
                  </v-card-text>
                </v-card>
              </v-menu>
            </v-card-title>
            <v-card-text>
              <professionals-table :professionals="professionals" :search="filterBy" :loading="searching"></professionals-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const ProfessionalsTable = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "professionals" */ '@/Components/Professionals/professionals')
  import HelpMixin from '@/Mixins/helpComponent'

  export default {
    name: 'Professionals',
    layout,
    props: [
      'professionals',
      'professions',
      'profession',
      'activated'
    ],
    mixins: [
      HelpMixin,
    ],
    components: {
      ProfessionalsTable,
    },
    metaInfo () {
      return {
        title: 'Professionals',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        filterBy: '',
        status: this.activated,
        pro: this.profession,
        searching: false,
      }
    },
    methods: {
      getProfessions () {
        this.$inertia.visit('/professionals?activated=' + this.status + '&profession=' + this.pro, {
          preserveScroll: true,
          preserveState: true,
          onBefore: () => this.searching = true,
          onFinish: () => this.searching = false,
        })
      }
    },
    watch: {
      'status': 'getProfessions',
      'pro': 'getProfessions'
    }
  }
</script>
